export default function Hotel(){

    return(
        <>
        <div>hiiii</div>
        </>
    )
}